var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmbulanceicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_153_1567)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39 0.5C60.263 0.5 77.5 17.737 77.5 39C77.5 60.263 60.263 77.5 39 77.5C17.737 77.5 0.5 60.263 0.5 39C0.5 17.737 17.737 0.5 39 0.5Z",
    fill: "#FFBEBE",
    stroke: "#FF3D42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5 77C60 75.5 73.5 62.5 76.5 45L59.5788 27.4317L59.0235 30.5809L52.3438 24L15 50.9507L41.5 77Z",
    fill: "#F8979A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8689 35.9413L59.2618 27.0605H50.7026V50.6863H69.2787V37.8648L64.8689 35.9413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8281 29.4023H58.043L62.004 35.9531H53.8281V29.4023Z",
    fill: "#68B6F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1445 23.6133H52.1016V50.6863H15.1445V23.6133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.584 23.6133H52.1014V50.6863H33.584V23.6133Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1445 43.1133H52.1016V46.0585H15.1445V43.1133Z",
    fill: "#F98585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.584 43.1133H52.1014V46.0585H33.584V43.1133Z",
    fill: "#E27979"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4363 56.9325C63.806 56.9325 66.5377 54.2008 66.5377 50.8311C66.5377 47.4614 63.806 44.7297 60.4363 44.7297C57.0666 44.7297 54.335 47.4614 54.335 50.8311C54.335 54.2008 57.0666 56.9325 60.4363 56.9325Z",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4361 53.6074C61.9695 53.6074 63.2126 52.3643 63.2126 50.8309C63.2126 49.2975 61.9695 48.0544 60.4361 48.0544C58.9027 48.0544 57.6597 49.2975 57.6597 50.8309C57.6597 52.3643 58.9027 53.6074 60.4361 53.6074Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2928 56.9325C27.6625 56.9325 30.3941 54.2008 30.3941 50.8311C30.3941 47.4614 27.6625 44.7297 24.2928 44.7297C20.9231 44.7297 18.1914 47.4614 18.1914 50.8311C18.1914 54.2008 20.9231 56.9325 24.2928 56.9325Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2926 53.6074C25.826 53.6074 27.069 52.3643 27.069 50.8309C27.069 49.2975 25.826 48.0544 24.2926 48.0544C22.7592 48.0544 21.5161 49.2975 21.5161 50.8309C21.5161 52.3643 22.7592 53.6074 24.2926 53.6074Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3614 35.496L39.3613 31.0273H35.8574V27.5234H31.3887V31.0273L27.8848 31.0272V35.496H31.3887V38.9999H35.8574V35.496H39.3614Z",
    fill: "#EC5353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.361 31.0273H35.8571V27.5234H33.5845V38.9999H35.8571V35.496H39.361V31.0273Z",
    fill: "#D13135"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_153_1567"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmbulanceicon);
export default __webpack_public_path__ + "static/media/Ambulanceicon.b19e2327a43a9b637905eb919d18964b.svg";
export { ForwardRef as ReactComponent };